export default {
    type: 'hero-text',
    name: 'Hero Text',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleHeroText',
            loader: () => import('./ModuleHeroText')
        },
        form: {
            name: 'ModuleHeroTextForm',
            loader: () => import('./ModuleHeroTextForm')
        }
    }
};
